<template>
    <tr>
        <th v-for="col in columns" v-if="$source.isVisible(col)" class="grid-filter-th">
            <slot :name="`filter-${col.field}`" :col="col">
                <oc-form :nested="true" :model="form" style="min-width: 58px;">
                    <oc-form-field
                        v-if="hasFilter(col)"
                        :name="col.field"
                        v-model="form[col.field]"
                        :displayLabel="false"
                        :indicationInvalid="false"
                        :indicationValid="false"
                        placeholderPrefix="Search "
                        size="small"
                        class="grid-filter-input"
                        v-bind="filterAttrs(col)"
                        v-on="filterEvents(col)"
                        $mode="edit"
                        theme="default"
                    />

                    <oc-button
                        v-if="col.filterButton && $source.filterButtonUseIcon === false"
                        type="primary"
                        size="small"
                        class="grid-filter-btn"
                        :text="$source.filterButtonText"
                        @click="onFilter"
                    />

                    <oc-button
                        v-if="col.filterButton && $source.filterButtonUseIcon"
                        type="primary"
                        size="small"
                        class="grid-filter-btn"
                        :title="$source.filterButtonText"
                        icon="filter"
                        @click="onFilter"
                    />

                    <oc-button
                        v-if="col.filterButton && col.filterResetButton !== false && hasAnyFilter()"
                        class="grid-reset-filter-btn"
                        type="secondary"
                        size="small"
                        icon="times"
                        :title="$source.filterResetButtonText"
                        @click="onResetFilter"
                    />
                </oc-form>
            </slot>
        </th>
    </tr>
</template>

<script>
import {mergeDeep} from '@utils'
import Form from '@/helpers/Form'

import DateTimeRangeInput from '@/components/ui/table/plugins/Filters/predefined/DateTimeRangeInput'
import DateTimeInput from '@/components/ui/table/plugins/Filters/predefined/DateTimeInput'
import DateInput from '@/components/ui/table/plugins/Filters/predefined/DateInput'

export default {
    name: 'oc-filters-after-header',
    inject: ['$source'],
    props: ['columns'],
    data() {
        let form = this.$source.filterModel

        if( false === form ) {
            form = new Form()
        }

        return {
            form,
            currentFilters: {},
            predefinedFilters: {
                [DateTimeRangeInput.name]: DateTimeRangeInput,
                [DateTimeInput.name]: DateTimeInput,
                [DateInput.name]: DateInput
            }
        }
    },
    watch: {
        $route: {
            handler() {
                this.scanQueryString(true)
            }
        }
    },
    created() {
        if( this.$source.filterApplyOnStartup ) {
            setTimeout(() => {
                this.onFilter(false)
            }, 0)
        }
        this.scanQueryString(false)
    },
    methods: {
        scanQueryString(resetPaging = false) {
            if ( ! this.$source.filterUseRouter ) {
                return
            }

            setTimeout(() => {
                let hasChange = false

                for( let key in this.$route.query ) {
                    if( key.indexOf(this.$source.filterParam) === 0 ) {
                        let parsedKey = key.substr(this.$source.filterParam.length)
                        let value = this.$route.query[key]

                        if( String(this.form[parsedKey]) !== String(value) ) {
                            hasChange = true
                            this.form.set(parsedKey, value)
                        }
                    }
                }

                let formData = this.form.all()
                for( let key in formData ) {
                    if( this.$route.query[this.$source.filterParam + key] === undefined && formData !== undefined && formData[key] !== '' ) {
                        this.form.set(key, '')
                    }
                }

                if( hasChange ) {
                    this.onFilter(resetPaging)
                }
            }, 0)
        },
        hasFilter(col) {
            if(col.filter === false) {
                return false
            }
            return col.field !== undefined && (this.$source.filter === '*' || col.filter || inArray(col.field, this.$source.filter))
        },
        getFilter(col) {
            let filter = typeOf(col.filter) === 'function'
                ? col.filter(col, this.form)
                : col.filter

            if( ! isObject(filter) ) {
                if( this.predefinedFilters.hasOwnProperty(filter) ) {
                    filter = this.predefinedFilters[filter].filter(col, this.form)
                } else {
                    filter = {}
                }
            } else if( filter.predefined !== undefined && this.predefinedFilters.hasOwnProperty(filter.predefined) ) {
                return mergeDeep(
                    {},
                    this.predefinedFilters[filter.predefined].filter(col, this.form),
                    filter
                )
            }

            return filter
        },
        filterAttrs(col) {
            let filter = this.getFilter(col)

            if( filter.label === undefined ) {
                filter.label = col.title
            }

            return filter
        },
        filterEvents(col) {
            let filter = this.getFilter(col)

            let events = typeOf(filter.on) === 'function'
                ? filter.on(col, this.form)
                : filter.on

            return events
        },
        onFilter(resetPaging = true) {
            let appliedFilters = this.form.getData()

            let hasFilterChanges = true

            if ( this.$source.filterUseRouter )
            {
                let queryParams = Object.assign({}, this.$route.query)

                for( let param in appliedFilters ) {
                    let queryKey = this.$source.filterParam + param
                    let value = appliedFilters[param]

                    if( value === '' || value === undefined ) {
                        delete queryParams[queryKey]
                    } else {
                        queryParams[queryKey] = value
                    }
                }

                if( toJson(queryParams) !== toJson(this.$route.query) )
                {
                    this.$router.replace({query: queryParams})
                }
                else
                {
                    hasFilterChanges = false
                }
            }

            for( let param in appliedFilters ) {
                if( appliedFilters[param] === '' || appliedFilters[param] === undefined ) {
                    delete appliedFilters[param]
                }
            }

            if( resetPaging && this.$source.goToPage !== undefined && ((this.$source.filterUseRouter && hasFilterChanges) || toJson(this.currentFilters) !== toJson(appliedFilters)) ) {
                this.$source.goToPage(1)
            }

            this.$source.conditionsState.filters = appliedFilters
            this.currentFilters = appliedFilters

            this.$source.$emit('on-filter', this.$source.conditionsState.filters)
            this.$source.$emit('change-internal', this.$source.conditionsState)
        },
        onResetFilter() {
            this.form.keys().forEach( key => {
                this.form.set(key, '')
            })

            this.onFilter()
        },
        hasAnyFilter() {
            let filters = this.form.getData()

            let has = Object.keys(this.currentFilters).length > 0

            for(let field in filters) {
                if( filters[field] !== '' ) {
                    has = true
                    break
                }
            }

            return has
        }
    }
}
</script>

<style>
.table .grid-filter-th {vertical-align:middle;}
.table .grid-filter-input {margin-bottom:0;}
</style>
